import React from 'react';
import { Nav, Image } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import {
    LayoutDashboard,
    ShoppingBag,
    ClipboardList,
    Layers,
    Users,
    Truck,
    UserCog,
    BarChart2,
    Settings,
    ChevronRight,
    Store
} from 'lucide-react';
import { NAV_ITEMS } from '../../utils/constants';
import useAuth from '../../hooks/useAuth';

const Sidebar = ({ isOpen }) => {
    const location = useLocation();
    const { user } = useAuth();

    // Get user roles
    const userRoles = user?.roles?.map(role => {
        if (typeof role === 'string') {
            return role.replace('ROLE_', '');
        }
        return role.name.replace('ROLE_', '');
    }) || [];

    // Filter navigation items based on user roles
    const filteredNavItems = NAV_ITEMS.filter(item => {
        return item.roles.some(role => userRoles.includes(role));
    });

    // Map icon name to icon component
    const getIcon = (iconName) => {
        switch (iconName) {
            case 'LayoutDashboard':
                return <LayoutDashboard size={20} />;
            case 'ShoppingBag':
                return <ShoppingBag size={20} />;
            case 'ClipboardList':
                return <ClipboardList size={20} />;
            case 'Layers':
                return <Layers size={20} />;
            case 'Users':
                return <Users size={20} />;
            case 'Truck':
                return <Truck size={20} />;
            case 'UserCog':
                return <UserCog size={20} />;
            case 'BarChart2':
                return <BarChart2 size={20} />;
            case 'Settings':
                return <Settings size={20} />;
            case 'Store':
                return <Store size={20} />;
            default:
                return <ChevronRight size={20} />;
        }
    };

    return (
        <div className={`sidebar bg-white text-dark ${isOpen ? 'open' : 'closed'}`}
            style={{
                width: isOpen ? '250px' : '0',
                minHeight: '100vh',
                transition: 'width 0.3s ease',
                overflowX: 'hidden',
                position: 'fixed',
                top: '0',
                left: '0',
                zIndex: 1000,
                
            }}>
            <div className="d-flex flex-column p-3 h-100">
    {/* Section du logo */}
    <div className="p-3 mb-4 border-bottom border-secondary">
        <div className="d-flex align-items-center justify-content-center mb-3">
            <img
                src="/senoscar/images/logoSO.png"  // Remplace ceci par le chemin réel de ton logo
                alt="SEN OSCAR Logo"
                style={{
                    width: '200px',  // Ajuste la taille selon tes besoins
                    height: 'auto',
                    marginBottom: '10px'
                }}
            />
        </div>
    </div>

    {/* Section du menu de navigation */}
    <Nav className="flex-column mb-auto">
        {filteredNavItems.map((item, index) => (
            <NavLink
                key={index}
                to={item.path}
                className={({ isActive }) =>
                    `nav-link py-2 px-3 mb-1 rounded ${isActive ? 'active text-white' : 'text-dark'}`
                }
                style={({ isActive }) => ({
                    backgroundColor: isActive ? '#b5835a' : 'transparent',
                    transition: 'background-color 0.3s ease' // Ajout d'une transition fluide
                })}
            >
                <div className="d-flex align-items-center">
                    <span className="me-3">
                        {getIcon(item.icon)} {/* Assurez-vous que getIcon(item.icon) retourne un élément valide */}
                    </span>
                    <span>{item.label}</span> {/* Affiche le label du lien */}
                </div>
            </NavLink>
        ))}
    </Nav>

    {/* Section utilisateur connecté */}
    <div className="mt-auto p-3 border-top border-secondary">
        <div className="d-flex align-items-center">
            <div className="rounded-circle bg-secondary p-2 me-2">
                <Users size={18} className="text-dark" />
            </div>
            <div>
                <div className="small text-dark">Connecté en tant que</div>
                <div className="fw-semibold">{user?.username || 'User'}</div>
            </div>
        </div>
    </div>
</div>

        </div>
    );
};

export default Sidebar;